import { Component } from 'react';
import { DataGrid, GridRowsProp, GridColDef } from '@material-ui/data-grid';
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import LabelIcon from '@material-ui/icons/Label';
import Tooltip from '@mui/material/Tooltip';
// import CodeIcon from '@material-ui/icons/Code';
// import CodeIcon from '@material-ui/icons/Code';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import VisibilityIcon from '@material-ui/icons/Visibility';

import Switcher from '../switcher/switcher';
import InputItemsPerPage from '../inputItemsPerPage/inputItemsPerPage';

import ScrollDialog from '../scrollDialog/scrollDialog';
import TableContext from '../tableContext/tableContext';

import ReactApiService from '../../services/reactApiService'
// import AppConfig from '../../services/appConfig';
import './tableOptions.css';

// export const TableContext = createContext();

export default class TableOptions extends Component {
		
  constructor(props) {

    super(props);

		this.dataService = new ReactApiService();
		this.config = props.config;
		this.rowClassWrapper = 'App-table--row';
		this.rowHeight = 28;
	
		this.state = {
      error: null,
      isLoaded: false,
      optionName: false,
      tableItems: this.rows,
      tableColumns: this.columns,
      tablePageSize: this.getTablePageSize(),
      itemsPerPage: this.getItemsPerPage(props),
			responseMessage: 'Something went wrong.',
			visibleItemsPerPage: typeof this.props.visibleItemsPerPage === 'boolean'  ? this.props.visibleItemsPerPage : true
    };
		// console.log('props :: ', props );
  }

	tableClassWrapper = 'App-table';
	
	getTablePageSize = () => {
		
		if ( 'undefined' === typeof this.config.endPoints[this.props.endpoint]['options'] ) {
			return this.config.defaultTablePageSize * 1
		}		
	
		if ( 'undefined' === typeof this.config.endPoints[this.props.endpoint]['options']['tablePageSize'] ) {
			return this.config.defaultTablePageSize * 1
		}		
		
		return this.config.endPoints[this.props.endpoint]['options']['tablePageSize'] * 1;
	}
	
	getItemsPerPage = (props) => {

		let itemsPerPageOption = false;
		
		if ( 'undefined' === typeof this.config.endPoints[props.endpoint]['options'] ) {
			return itemsPerPageOption;
		}
		
		if ( 'undefined' === typeof this.config.endPoints[props.endpoint]['options']['itemsPerPage'] ) {
			return itemsPerPageOption;
		}
		
		if ( 'number' === typeof this.config.endPoints[props.endpoint]['options']['itemsPerPage'] ) {
			return this.config.endPoints[props.endpoint]['options']['itemsPerPage'] * 1;
		}
		
		let itemsPerPage = null;
		itemsPerPageOption = this.config.endPoints[props.endpoint]['options']['itemsPerPage'];
		if ( localStorage.hasOwnProperty(itemsPerPageOption) ) {
			itemsPerPage = localStorage.getItem( itemsPerPageOption );
		}
		if ( itemsPerPage !== null ) {
			return itemsPerPage * 1;
		}
		return props.endpoint === 'allOptions' ? props.config.allOptionsTableItemsPerPage * 1 : props.config.optionsToTranslateTableItemsPerPage * 1;
	}

	onAfterEditItemsPerPage = (attrs) => {
		let body = {
			tableName: this.config.endPoints[this.props.endpoint]['tableName'],
			itemsPerPage: attrs.itemsPerPage,
			itemsPerPageOption: this.config.endPoints[this.props.endpoint]['options']['itemsPerPage'],
			endpoint:this.props.endpoint
		}
		this.dataService.post({endpoint:'updateItemsPerPage',body:body})
		.then( 
			(response) => {}
		).then(() => {
			this.setState( prevState => {
				return {
					tablePageSize: attrs.itemsPerPage * 1,
					itemsPerPage: attrs.itemsPerPage * 1
				}
			})
			localStorage.setItem(
				this.config.endPoints[this.props.endpoint]['options']['itemsPerPage'],
				attrs.itemsPerPage
			);
		})		
	}
	
	onAfterSwitcherSave(attrs) {
		this.setState( prevState => {
			const items = prevState.tableItems.map((item, j) => {
				if (item.optionID === attrs.row.id) {
					item.checked = attrs.checked;
				}
				return item;
			});
			return {
				tableItems:items,
			};
		});			
  }

	renderTranslateItCell = (GridCellParams) => {
		return ( 
			<Switcher checked={GridCellParams.row.checked} row={GridCellParams.row} afterSave={this.onAfterSwitcherSave.bind(this)} />
		);
	}

	renderHasMLStringCell = (GridCellParams) => {
		return GridCellParams.value ? 'yes' : ' - '
	}
	
	renderOptionNameCell = (GridCellParams) => {
		// !!!!!!
		let optionActiveThemeClass = ' optionActiveTheme';
		// if ( GridCellParams.row.optionActiveTheme ) {
			// console.log( 'GridCellParams:: ', GridCellParams );
			// optionActiveThemeClass = ' optionActiveTheme';
		// }
		let tooltip = '';
		if ( GridCellParams.row.themeStatus === 'active' ) {
			tooltip = 'Active theme options'
		} else if ( GridCellParams.row.themeStatus === 'parent' ) {
			tooltip = 'Parent theme options'
		} else if ( GridCellParams.row.themeStatus === 'child' ) {
			tooltip = 'Child theme options'
		} else {
			optionActiveThemeClass = '';
		}
		
		let iconPreviewClass = "icon-action icon-preview";
		if ( ! this.config.debug ) {
			iconPreviewClass += ' hidden';
		}

		return (
			<>
				<span className={"option-name"}>{GridCellParams.value}</span>
				<span className={"actions"}>
					<span className={"icon-action icon-label"+optionActiveThemeClass}>
						<Tooltip title={tooltip} placement="right-start">
							<LabelIcon data-value={GridCellParams.value} />
						</Tooltip>	
					</span>
					<span className={iconPreviewClass}><SearchOutlinedIcon data-value={GridCellParams.value} onClick={this.iconPreviewHandleClick} /></span>
				</span>
			</>
		)
	}	
	
	iconPreviewHandleClick = (e) => {
		let optionName = false;
		if ( 'undefined' === typeof e.target.dataset.value ) {
			optionName = e.target.parentNode.dataset.value;
		} else {
			optionName = e.target.dataset.value;
		}
		
		this.setState( prevState => {
			return {
				optionName: optionName
			}
		});
	}
	
  rows: GridRowsProp = [];	
	
  columns: GridColDef[] = [
		{ 
			field: 'optionID', 
			headerName: 'ID', 
			width:100,
			sortable:true, 
		},
		{ 
			field: 'translateIt', 
			headerName: 'Active', 
			width:120, 
			sortable:true, 
			align:'center', 
			renderCell:this.renderTranslateItCell 
		},
		{ 
			field: 'optionName', 
			headerName: 'Option name', 
			width:400, 
			sortable:true, 
			editable: false, 
			renderCell:this.renderOptionNameCell,
			cellClassName: 'option-name--cell'
		},
		{ 
			field: 'hasMLString',
			headerName: 'has multilingual value',
			width: 220,
			sortable: true, 
			filterable: false, 
			headerAlign: 'center',
			align: 'center', 
			renderCell: this.renderHasMLStringCell 
		},
  ];
 
	resizeGridContainer = () => {
		// Material-UI: useResizeContainer - The parent of the grid has an empty height.
		// You need to make sure the container has an intrinsic height.
		// The grid displays with a height of 0px.
		// You can find a solution in the docs:
		// https://material-ui.com/components/data-grid/layout/
		let rows = document.getElementsByClassName(this.rowClassWrapper);
		let height = this.rowHeight;
		if ( rows.length > 0 ) {
			let tableWrapper = document.getElementsByClassName(this.tableClassWrapper);
			// let newHeight = height * ( this.state.tablePageSize * 1 + 4 );
			let newHeight = height * ( this.getTablePageSize() * 1 + 4 );
			tableWrapper[0].style['height'] = newHeight+'px';
		} else {
			let tableWrapper = document.getElementsByClassName(this.tableClassWrapper);
			if ( tableWrapper.length > 0 ) {
				// let newHeight = height * ( this.state.tablePageSize * 1 + 4 );
				let newHeight = height * ( this.getTablePageSize() * 1 + 4 );
				tableWrapper[0].style['height'] = newHeight+'px';			
			}						
		}
	}
 
	getData = () => {
		this.dataService.get(this.props.endpoint)
		.then( 
			(response) => {
				if ( response.response === 'ok' ) {
					this.setState({
						isLoaded: true,
						responseMessage: response.message,
						tableItems: response.data.map( item => {
							return {
								id: parseInt(item.option_id),
								optionID: parseInt(item.option_id),
								checked: item.translateIt,
								optionName: item.option_name,
								hasMLString: item.hasMLString,
								translateIt: item.translateIt,
								themeStatus: item.themeStatus
							}
						}) 
					});	
				} else {
					this.setState({
						isLoaded: true,
						responseMessage: response.message
					});
				}					
			},
			// Note: it's important to handle errors here
			// instead of a catch() block so that we don't swallow
			// exceptions from actual bugs in components.
			(error) => {
				this.setState({
					isLoaded: true,
					error
				});
			}
		).then(() => {
			// this.resizeGridContainer() @see componentDidUpdate.
		})		
	}
 
  componentDidMount() {
		this.getData();
  }  
	
	componentWillUnmount(){}
	
	componentDidUpdate() {
		this.resizeGridContainer()
  }
  
	resetOptionName = () => {
		this.setState( prevState => {
			return {
				optionName: false
			}
		});
	}

	// <TableContext.Provider value={this.state}>
		// <ScrollDialog />		
	// </TableContext.Provider>
	// <ScrollDialog open={viewOption} />
	
	render() {

    const { 
			error, 
			isLoaded, 
			tableItems, 
			optionName, 
			itemsPerPage, 
			tableColumns, 
			responseMessage, 
			visibleItemsPerPage 
		} = this.state;
		
		if ( error ) {
      return <div>Error: {error.message}</div>;
    } else if ( !isLoaded ) {
      return <div className="App-table-preload">Loading...</div>;
    } else {
			if ( tableItems.length === 0 ) {
				return ( <div style={{height:200,width:'100%'}}>{responseMessage}</div> );
			} else {
				return (
					<>
						<TableContext.Provider value={{optionName:optionName, reset:this.resetOptionName}}>
							<ScrollDialog />	
						</TableContext.Provider>
						<InputItemsPerPage 
							itemsPerPage={itemsPerPage}
							afterEdit={this.onAfterEditItemsPerPage.bind(this)}
							visible={visibleItemsPerPage}
						/>
						<div className={this.tableClassWrapper}>
							<DataGrid 
								rowHeight={this.rowHeight} 
								pageSize={itemsPerPage} 
								rowsPerPageOptions={[itemsPerPage]} 
								rows={tableItems}
								columns={tableColumns}
								getRowClassName={()=>this.rowClassWrapper} 
							/>
						</div>
					</>
				);
			}
    }
  }
}